<template>
  <div>
    <h2 class="step-name">Deer - Parasites</h2>

    <div class="step-section">
      <discussion-points
        title="Discussion"
        comments-field="deer_parasites_and_trace_elements_discussion"
        points="Ostertagiosis (Fading Elk), Lungworm, Gastrointestinal parasites, Copper and Selenium deficiency; current supplementation, testing, clinical disease (Swayback)"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <h3>Drench and Trace Element Product Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
            <th>Doses</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('deer_drench_trace_element_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
            <td class="text-left">{{ row['Doses'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="step-section">
      <radio-input
        label="Have you had an issue with Parasites?"
        field-name="deer_issue_with_parasites"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <radio-input
        label="Do you routinely treat for lungworm?"
        field-name="deer_treat_for_lungworm"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <discussion-points
        title="Drench Discussion"
        comments-field="deer_parasites_drench_discussion"
        points="weaning weights, products used, fading elk"
      >
      </discussion-points>

      <radio-input
        label="Do you CARLA test?"
        field-name="deer_carla_test"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>
    </div>

    <drug-allocation-cart :drugGroups="getFieldValue('DRUG_GROUPS')" animalType="deer"> </drug-allocation-cart>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationCart from './DrugAllocationCart'

export default {
  name: 'DeerParasites',
  mixins: [baseComponent],
  components: {
    DrugAllocationCart,
  },
}
</script>
